import axios from "axios";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import URLPage from "../endPoints/endpoints";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPrint } from "@fortawesome/free-solid-svg-icons";
import generarPDF from "../utilities/create-pdf";
import 'bootstrap/dist/css/bootstrap.min.css';
import Spinner from "../components/Spinner/Spinner";


function CheckVanFletId() {
  const [vanId, setVanId] = useState(null);
  const { id } = useParams();

  const fetchVanId = async () => {
    try {
      const response = await axios.get(
        `${URLPage}/api/van/clients/${id}`
      );

     
      setVanId(response.data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (id) fetchVanId();
  }, [id]);
    
    
    if (vanId) {
        return <>  
     
      <div className="m-4 mb-5">
      <h3><strong className='title'>Check Van Flet</strong><button className="btn btn-primary ms-4" onClick={() => generarPDF(vanId)}><FontAwesomeIcon className="me-2" icon={faPrint}/> Print</button></h3>
      <p>Date: {vanId.date} </p>
      <p>Check created by: {vanId.userMail}</p>
      <p>Vehicule Registration Number: {vanId.vehicleRegistrationNumber}</p>
      <hr></hr>

      <h4>Exterior Condition</h4>
      <p>Bodywork: {vanId.bodyWork ? <span className="text-success">✅</span> : <span className="error">X</span>}</p>
      <p>Bodywork panels: {vanId.bodyWorkPanels ? <span className="text-success">✅</span> : <span className="error">X</span> }</p>
      <br/>
      <p>Mirrors: {vanId.mirrors ? <span className="text-success">✅</span> : <span className="error">X</span> }</p>
      <p>Mirrors Clean: {vanId.mirrorsClean ? <span className="text-success">✅</span> : <span className="error">X</span> }</p>
      <br/>
      <p>Windows: {vanId.windows ? <span className="text-success">✅</span> : <span className="error">X</span> }</p>
      <p>Windows Clean: {vanId.windowsClean ? <span className="text-success">✅</span> : <span className="error">X</span> }</p>
      <br/>
      <p>Wipers: {vanId.wipers ? <span className="text-success">✅</span> : <span className="error">X</span> }</p>
      <p>Windscreen Washer: {vanId.windScreenWasher ? <span className="text-success">✅</span> : <span className="error">X</span> }</p>
      <p>Rear Wiper: {vanId.rearWiper ? <span className="text-success">✅</span> : <span className="error">X</span> }</p>
      <br/>
      <p>Headlights: {vanId.headLights ? <span className="text-success">✅</span> : <span className="error">X</span> }</p>
      <p>Sidelights (Parking Lights): {vanId.sideParkingLights ? <span className="text-success">✅</span> : <span className="error">X</span> }</p>
      <p>Indicators: {vanId.indicators ? <span className="text-success">✅</span> : <span className="error">X</span> }</p>
      <p>Brake Lights: {vanId.brakeLights ? <span className="text-success">✅</span> : <span className="error">X</span> }</p>
      <p>Hazard Warning Lights: {vanId.hazardWarningLights ? <span className="text-success">✅</span> : <span className="error">X</span> }</p>
      <p>Number Plate Light: {vanId.numberPlateLight ? <span className="text-success">✅</span> : <span className="error">X</span> }</p>
      <p>Fog Lights: {vanId.fogLights ? <span className="text-success">✅</span> : <span className="error">X</span> }</p>
      <br/>
      <p>Tyres Condition: {vanId.tyreCondition ? <span className="text-success">✅</span> : <span className="error">X</span> }</p>
      <p>Tyres Pressure: {vanId.tyrePressure ? <span className="text-success">✅</span> : <span className="error">X</span> }</p>
      <p>Tyres Depth: {vanId.tyresDepth ? <span className="text-success">✅</span> : <span className="error">X</span> }</p>
      <p>Valve caps: {vanId.valveCaps ? <span className="text-success">✅</span> : <span className="error">X</span> }</p>
      <p>Wheels: {vanId.wheels ? <span className="text-success">✅</span> : <span className="error">X</span> }</p>
      <p>Number Plates: {vanId.numberPlateLight ? <span className="text-success">✅</span> : <span className="error">X</span> }</p>
      
      <h4>Under the Bonnet</h4>
      <p>Engine Oil: {vanId.engineOil ? <span className="text-success">✅</span> : <span className="error">X</span>}</p>
      <p>Coolant: {vanId.coolant ? <span className="text-success">✅</span> : <span className="error">X</span> }</p>
      <p>Brake Fluid: {vanId.brakeFluid ? <span className="text-success">✅</span> : <span className="error">X</span>}</p>
      <p>Power Steering Fluid: {vanId.powerSteeringFluid ? <span className="text-success">✅</span> : <span className="error">X</span>}</p>
      <p>Leaks: {vanId.leaks ? <span className="text-success">✅</span> : <span className="error">X</span> }</p>
      
      <h4>Interior Checks</h4>
      <p>Driver Seat: {vanId.driverSeat ? <span className="text-success">✅</span> : <span className="error">X</span>}</p>
      <p>Pedals: {vanId.pedals ? <span className="text-success">✅</span> : <span className="error">X</span> }</p>
      <p>Steering Wheel: {vanId.steeringWheel ? <span className="text-success">✅</span> : <span className="error">X</span>}</p>
      <p>Seat Belts: {vanId.seatBelts ? <span className="text-success">✅</span> : <span className="error">X</span> }</p>
      <p>Horn: {vanId.horn ? <span className="text-success">✅</span> : <span className="error">X</span> }</p>
      <p>Warning Lights: {vanId.warningLights ? <span className="text-success">✅</span> : <span className="error">X</span>}</p>
      <p>Foot Brake: {vanId.footBrake ? <span className="text-success">✅</span> : <span className="error">X</span> }</p>
      <p>Parking Brake: {vanId.parkingBrake ? <span className="text-success">✅</span> : <span className="error">X</span>}</p>
      <p>Load Security: {vanId.loadSecurity ? <span className="text-success">✅</span> : <span className="error">X</span>}</p>

      <h4>Documentation Equipment</h4>
      <p>Vehicule Documentation: {vanId.vehiculeDocumentation ? <span className="text-success">✅</span> : <span className="error">X</span> }</p>
      <p>Warning triangle and high-visibility vest: {vanId.warningTrianguleHighVibilityVest ? <span className="text-success">✅</span> : <span className="error">X</span> }</p>
      <p>First-aid kit: {vanId.firstAidKit ? <span className="text-success">✅</span> : <span className="error">X</span>}</p>
      <p>Fire extinguer: {vanId.fireExtinguisher ? <span className="text-success">✅</span> : <span className="error">X</span>}</p>
      <hr></hr>
      <p>Additonal Report (optional): <i>{vanId.anotherReport ? vanId.anotherReport : ''}</i></p> 
      <div style={{height:'10px', background:'transparent', marginBottom:'10px'}}></div>
      </div>
      </>
    } else {
      return <>
        <Spinner/>
      </>
    }
};


export default CheckVanFletId;